import type { Theme } from "@mui/material/styles";
import type { AppFormLayoutStyles } from "../types";
import { FORM_CONTROL_MIN_HEIGHT } from "../tokens";

export function buildFormLayoutStyles(_theme: Theme): AppFormLayoutStyles {
  const appFormField = {
    width: "100%",
    maxWidth: "100%",
    "& .MuiOutlinedInput-root": {
      borderRadius: 1,
      minHeight: FORM_CONTROL_MIN_HEIGHT,
    },
    "& .MuiOutlinedInput-input, & .MuiInputBase-input": {
      color: "text.primary",
      py: 0.75,
    },
    "& .MuiInputBase-input::placeholder": {
      color: "text.secondary",
      opacity: 1,
    },
    "& .MuiSelect-select": {
      color: "text.primary",
      py: 0.75,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiFormHelperText-root": {
      mt: 0.5,
      mx: 0.25,
      lineHeight: 1.3,
    },
    "& .MuiInputLabel-root": {
      lineHeight: 1.2,
    },
    "& .MuiInputLabel-shrink": {
      // Keep notch labels inside the field's vertical budget (pair with grid row gap).
      transform: "translate(14px, -8px) scale(0.85)",
    },
  };

  return {
    appFormField,
    formControlLabelAlign: {
      ml: 0,
      mr: 0,
      minHeight: FORM_CONTROL_MIN_HEIGHT,
      height: "auto",
      alignItems: "center",
    },
    formRowButton: {
      minHeight: FORM_CONTROL_MIN_HEIGHT,
      minWidth: 96,
      whiteSpace: "nowrap",
    },
    chartOptionInput: {
      width: "100%",
      "& .MuiInputBase-root": {
        minHeight: FORM_CONTROL_MIN_HEIGHT,
        height: FORM_CONTROL_MIN_HEIGHT,
        boxSizing: "border-box",
      },
      "& .MuiOutlinedInput-input, & .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        py: 0,
      },
    },
    chartOptionToggleGroup: {
      width: "100%",
      display: "flex",
      "& .MuiToggleButtonGroup-grouped": {
        flex: 1,
      },
      "& .MuiToggleButton-root": {
        flex: 1,
        minHeight: FORM_CONTROL_MIN_HEIGHT,
        px: 1,
      },
    },
    chartOptionSectionLabel: {
      display: "block",
      mb: 0.75,
      fontWeight: 700,
      letterSpacing: 0.4,
      color: "text.secondary",
      fontSize: "0.7rem",
      textTransform: "uppercase",
    },
    chartOptionFieldLabel: {
      position: "relative",
      transform: "none",
      fontSize: "0.72rem",
      fontWeight: 600,
      lineHeight: 1.2,
      color: "text.secondary",
      mb: 0.35,
    },
    chartOptionFieldControlBox: {
      minHeight: FORM_CONTROL_MIN_HEIGHT,
      width: "100%",
      display: "flex",
    },
    chartOptionOutlinedInput: {
      ...appFormField,
      width: "100%",
      "& .MuiInputBase-root": {
        minHeight: FORM_CONTROL_MIN_HEIGHT,
        height: FORM_CONTROL_MIN_HEIGHT,
        boxSizing: "border-box",
      },
      "& .MuiOutlinedInput-input, & .MuiSelect-select": {
        display: "flex",
        alignItems: "center",
        py: 0,
      },
    },
    chartOptionFormGrid: {
      "& > .MuiGrid-root": {
        display: "flex",
      },
    },
    pageSectionPanel: {
      p: 1.25,
      pb: 1.75,
      mb: 0,
      borderRadius: 1.25,
    },
    pageFilterPanel: {
      mb: 0,
      borderRadius: 1.25,
    },
    pageFilterPanelContent: {
      p: 1,
      pb: 1.5,
      "&:last-child": { pb: 1.5 },
    },
    pageStatCard: {
      borderRadius: 1.25,
      height: "100%",
    },
    pageStatCardContent: {
      p: 1,
      pb: 1.5,
      "&:last-child": { pb: 1.5 },
    },
    pageStatGrid: {
      mb: 0,
    },
  };
}
